import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';

export const onLearnMoreAboutPinsClick: () => AnalyticsEventPayload = (): AnalyticsEventPayload => {
	try {
		return {
			action: 'clicked',
			actionSubject: 'aiSearchBookmarkAddLearnMore',
			eventType: 'ui',
		};
	} catch (error) {
		logger.error({ error, functionName: 'onLearnMoreAboutPinsClick' });
		return {};
	}
};
